import styled from 'styled-components'
import { Colors } from '@qirapagos/lib/theme'
import { MotionStyle } from 'framer-motion'
import { DEVICES } from 'theme/devicesSizes'
import ButtonComponent from 'components/atoms/Button'
import { Image } from '@chakra-ui/react'
import { CSSProperties } from 'react'

export const ScreenContainer = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100vh;
  width: 100%;
  background-color: ${Colors.white};
  align-items: stretch;
  gap: 5%;

  @media ${DEVICES.tablet} {
    flex-direction: column;
  }
`

export const ImageContainer = styled.div`
  width: 50%;
  display: flex;
  
  @media ${DEVICES.tablet} {
    display: none;
  }
`

export const MainImage = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: fill; 
  display: block;
`

export const InformationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 116px 0;
  width: 45%;
  text-align: center;

  @media ${DEVICES.tablet} {
    width: 100%;
    margin-right: 0;
    padding: 40px 20px;
  }
`

export const slideStyle: MotionStyle = {
  position: 'relative',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  marginBottom: '50px'
}

export const mainContentContainerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%'
}

export const TextTitleText = styled.p`
  font-size: clamp(30px, 4vw, 40px);
  font-weight: 900;
  margin-bottom: 45px;
  line-height: 1.2;
  white-space: pre-line;
`

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 70px;
  width: 100%;
  max-width: 400px;
`

export const TextBodyText = styled.p`
  font-size: 1.1rem;
  margin-bottom: 20px;
  white-space: pre-line;
`

export const LoginButton = styled(ButtonComponent)`
  margin-bottom: 70px;
  width: 350px; 
`

export const StoresContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  gap: 15px;
  width: 100%;
`

export const Legend = styled.p`
  color: ${Colors.gray};
  text-align: justify;
  font-size: 10px;
  max-width: 500px;
  padding: 0 20px;
`
